import { useContext } from 'react'
import { UserContext } from 'contexts'
import { RoleTypeData } from 'hooks/useRoleTypes'

export default function useSponsorPermissions() {
  const { user } = useContext(UserContext)

  const getAllowedRoleTypes = (
    allRoleTypes: RoleTypeData[],
    selectedOuId?: number
  ): RoleTypeData[] => {
    if (!selectedOuId || !allRoleTypes) return allRoleTypes

    const sponsorOu = user.sponsor_for_ous.find(ou => ou.id === selectedOuId)
    if (!sponsorOu) return allRoleTypes

    // Empty array = no restrictions, return all role types
    if (!sponsorOu.limit_to_role_types || sponsorOu.limit_to_role_types.length === 0) {
      return allRoleTypes
    }

    // Filter to only allowed role types
    return allRoleTypes.filter(rt =>
      sponsorOu.limit_to_role_types.includes(rt.id)
    )
  }

  return { getAllowedRoleTypes }
}
